var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ImmersivePage",
    {
      staticClass: "manage-channel-page",
      attrs: { appBarTitle: _vm.appBarTitle, route: _vm.backRoute },
    },
    [
      _c(
        "KPageContainer",
        { staticClass: "device-container" },
        [
          !_vm.channel ? _c("TaskProgress") : _vm._e(),
          _vm.channel
            ? [
                _c(
                  "ChannelContentsSummary",
                  { attrs: { channel: _vm.channel } },
                  [
                    _vm.availableVersions.studioLatest >
                    _vm.availableVersions.installed
                      ? _c("NewChannelVersionBanner", {
                          staticClass: "banner",
                          attrs: {
                            version: _vm.availableVersions.studioLatest,
                          },
                          on: { click: _vm.handleClickViewNewVersion },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticStyle: { "text-align": "right" } },
                  [
                    _c("KButton", {
                      attrs: { text: _vm.$tr("importMoreAction") },
                      on: {
                        click: function ($event) {
                          _vm.shownModal = "IMPORT_MORE"
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "transition",
                  { attrs: { mode: "out-in" } },
                  [
                    !_vm.currentNode
                      ? _c("KLinearLoader", { attrs: { delay: false } })
                      : _c("ContentTreeViewer", {
                          style: {
                            borderBottomColor: _vm.$themeTokens.fineLine,
                          },
                          attrs: { node: _vm.currentNode, manageMode: true },
                        }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.shownModal === "DELETE"
            ? _c("DeleteResourcesModal", {
                attrs: { numberOfResources: _vm.resourceCounts.count },
                on: { cancel: _vm.closeModal, submit: _vm.handleDeleteSubmit },
              })
            : _vm._e(),
          _vm.shownModal === "EXPORT"
            ? _c("SelectDriveModal", {
                attrs: {
                  manageMode: true,
                  exportFileSize: _vm.resourceCounts.fileSize,
                },
                on: { cancel: _vm.closeModal, submit: _vm.handleExportSubmit },
              })
            : _vm._e(),
          _vm.shownModal === "IMPORT_MORE"
            ? _c("SelectTransferSourceModal", {
                attrs: { manageMode: true, pageName: _vm.selectSourcePageName },
                on: {
                  "update:pageName": function ($event) {
                    _vm.selectSourcePageName = $event
                  },
                  "update:page-name": function ($event) {
                    _vm.selectSourcePageName = $event
                  },
                  cancel: _vm.closeModal,
                  submit: _vm.handleSelectImportMoreSource,
                },
              })
            : _vm._e(),
          _c("SelectionBottomBar", {
            attrs: {
              objectType: "resource",
              actionType: "manage",
              resourceCounts: _vm.resourceCounts,
              disabled: !Boolean(_vm.currentNode) || _vm.bottomBarDisabled,
            },
            on: {
              selectoption: function ($event) {
                _vm.shownModal = $event
              },
            },
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }